const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const NOTIFICATIONS = {
    CREATE_NOTIFICATION: `${API_BASE_URL}/notifications/create/`,
    NOTIFICATIONS: `${API_BASE_URL}/notifications/`,
    NOTIFICATIONS_READ: (id) => `${API_BASE_URL}/notifications/notifications/${id}/mark-read/`,
  };
  
  export default NOTIFICATIONS;